import { Main } from "./Main";
import { User } from "./User";

const main = new Main();
const user = new User();

const ebi = {
    main,
    user,
};

export default ebi;